import { JobStatus, JobSub } from "@project/shared-types";
import { useMemo, useState } from "react";
import { Button } from "../../../../components/button/button";
import { FeedBack } from "../../../../components/FeedBack/FeedBack";
import { InputDatePicker } from "../../../../components/InputDatePicker/InputDatePicker";
import { Loader } from "../../../../components/Loader/Loader";
import { _size, _style } from "../../../../core/core";
import { JobService } from "../../model/job.service";
import "./CardJob.css";
import { EditorJobSubFixed } from "./EditorJob/EditorJobSubFixed";
import { JobRenderInfoList } from "./JobRenderInfoList";
import { JobViewer, JobViewerProps } from "./JobViewer";
import { getWorkImageUrl } from "./utils";

interface JobSubViewerProps extends JobViewerProps<JobSub> {
  is_edit: boolean;
}
export const JobSubViewer: React.FC<JobSubViewerProps> = ({
  job_data,
  work,
  children,
  onClick,
  is_edit,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [job, setJob] = useState(job_data);
  const [date, setDate] = useState(job.date_public);
  const [isChange, setIsChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    onClick?.(e);
    e.stopPropagation();
    e.preventDefault();
    setOpenModal((prev) => !prev);
  };

  const fetchChangeJob = async () => {
    try {
      if (!is_edit) return;
      setIsLoading(true);
      const updated = await JobService.changeJobApi(job, undefined, date);
      setIsLoading(false);
      setIsChange(false);
      setJob(updated as JobSub);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  const renderInfo = useMemo(() => {
    return JobService.getInfoForRenderSub(job, work);
  }, [job, work]);
  const getImageUrl = (image: string) => getWorkImageUrl(image);
  return (
    <JobViewer job_data={job} work={work} onClick={handleClick}>
      {is_edit && job.status == JobStatus.DO ? (
        <div className="card-job-b">
          <InputDatePicker
            value={date}
            setValue={setDate}
            labelOutside="Запланировать"
          ></InputDatePicker>
          {isChange && (
            <Button
              size={_size.S}
              style={_style.secondary2}
              width={"100%"}
              onClick={() => fetchChangeJob()}
            >
              {isLoading ? <Loader isLoading /> : "Сохранить"}
            </Button>
          )}
        </div>
      ) : (
        <div className="card-job-b">
          <JobRenderInfoList items={renderInfo} getImageUrl={getImageUrl} />
          {JobService.canFeedback(job.status) && (
            <FeedBack
              title="Оцените работу исполнителя"
              id={job.id}
              is_order={false}
            />
          )}
          <Button onClick={() => setOpenModal(true)}>Подробнее</Button>
        </div>
      )}
      <EditorJobSubFixed
        order_id={job.order_id}
        is_active={openModal}
        set_is_active={setOpenModal}
        job_data={job}
      ></EditorJobSubFixed>
    </JobViewer>
  );
};
